import { observer } from 'mobx-react-lite'
import React from 'react'
import Switch from '../../../../FormComponents/Switch'
import DefaultSection from './CampaignOverviewParts/DefaultSection'
import Platforms from './CampaignOverviewParts/Platforms'
import Sections from './CampaignOverviewParts/Sections'
import TimeframeSection from './CampaignOverviewParts/TimeframeSection'

export default observer(function CampaignOverview({ values, setFieldValue, handleChange, handleBlur, campaign, missingContentDates }) {

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
      <div className="flex justify-between items-center mb-8">
        <p className="font-bold text-xl dark:text-white">Campaign Overview</p>
        <Switch name="campaign_overview_visible" value={values.campaign_overview_visible} onChange={({ target: { checked }}) => setFieldValue('campaign_overview_visible', checked, true)} eyeSwitch />
      </div>
      {values.campaign_overview_visible && (
        <>
          <div className="border-1 w-full border-gray-100 dark:border-rb-dark-mode-lighter" />
          <DefaultSection values={values} title='Reason for the Campaign' handleBlur={handleBlur} handleChange={handleChange} setFieldValue={setFieldValue} />
          <DefaultSection values={values} title='Campaign Objective(s)' handleBlur={handleBlur} handleChange={handleChange} setFieldValue={setFieldValue} />
          <DefaultSection values={values} title='Target Audience' handleBlur={handleBlur} handleChange={handleChange} setFieldValue={setFieldValue} />
          <TimeframeSection values={values} title='Target Audience' handleBlur={handleBlur} setFieldValue={setFieldValue} missingContentDates={missingContentDates} />
          <Platforms />
          <Sections values={values} handleBlur={handleBlur} handleChange={handleChange} setFieldValue={setFieldValue} />
        </>
      )}
    </div>
  )
})